import { render, staticRenderFns } from "./reviewSurveyCard.vue?vue&type=template&id=65bfbc3c&scoped=true&"
import script from "./reviewSurveyCard.vue?vue&type=script&lang=js&"
export * from "./reviewSurveyCard.vue?vue&type=script&lang=js&"
import style0 from "./reviewSurveyCard.vue?vue&type=style&index=0&id=65bfbc3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bfbc3c",
  null
  
)

export default component.exports